import React, { useState } from "react";
import "./style.css";
import { Form, Button, Spinner, Row, Col } from "@themesberg/react-bootstrap";
import OurServiceImage from "../../../assets/ourService.png";
import Modal from "./Modal";
import { NotificationManager } from "react-notifications";
import ContactService from "../../services/ContactService";
const OurService = () => {
  const [hide, setHide] = useState(false);
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [subject, setSubject] = useState(
    "Objet : Recevoir une offre gratuitement"
  );
  const [telephone, setTelephone] = useState("");
  const [notification, setNotification] = useState("");
  const [loading, setLoading] = useState(false);
  const [notifType, setNotifType] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setNotifType("");

    try {
      const response = await ContactService.sendEmail({
        client_name: name,
        email: email,
        phone: telephone,
        subject: subject,
        description: message,
      });
      console.log(response);
      if (response.status === 200) {
        setNotifType("success");
        setNotification(
          "L'equipe EasyLab vous remercie pour votre intérêt. Restons en contact pour explorer plus d’opportunités",
          "Notification"
        );
        // NotificationManager.succes(
        //   "L'equipe EasyLab vous remercie pour votre interraction."
        // );
        setName("");
        setEmail("");
        setTelephone("");
        setMessage("");
        setLoading(false);
      }
    } catch (err) {
      setNotifType("error");
      setNotification(err?.response?.data?.message);
      setLoading(false);
    }
  };
  return (
    <>
      <div className={"ourServiceContainer"} id="services">
        <img src={OurServiceImage} />
        <div className={"ourServiceDescription"}>
          <h1>Pourquoi choisir EasyLab?</h1>
          <p>
            Prêt à passer à l'action ? Optimisez vos opérations quotidiennes
            pour une productivité maximale et boostez votre croissance : La
            plateforme EasyLab.tn vous procure tout ce dont vous aurez besoin
            pour organiser et manager votre Laboratoire.
          </p>
          <p>
            La Plateforme <span>Easylab.tn</span> vous procure tout ce dont vous
            avez besoin pour organiser votre Laboratoire.. Commencez votre
            experience dès Maintenant!
          </p>
          <ul className={hide ? "block" : ""}>
            <li>Etat instantané des travaux</li>
            <li>Système de facturation facile</li>
            <li>Gestion des paiements optimale</li>
            <li>Edition de la liste de service personalisable : Easy-to-Use</li>
          </ul>
          <div className={"buttonServiceContainer"}>
            <button
              className={"seeMoreServiceButton"}
              onClick={() => setHide(true)}
            >
              Voir Plus
            </button>
            <button className={"devisServiceButton"} onClick={handleOpen}>
              Devis Gratuit
            </button>
          </div>
        </div>
      </div>{" "}
      <Modal isOpen={open} onClose={handleClose}>
        {notification && notification.length > 0 ? (
          <div
            style={{
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <p className={notifType} style={{ textAlign: "center" }}>
              L'equipe <strong> EasyLab </strong> vous remercie pour votre
              intérêt. Restons en contact pour explorer plus d’opportunités
            </p>
            <button className={"ContactUsCancelButton"} onClick={handleClose}>
              A bientôt
            </button>
          </div>
        ) : (
          <Form onSubmit={handleSubmit} className={"ContactUsInput"}>
            <div
              style={{
                display: "flex",
                gap: "20px",
                width: "100%",
                marginBottom: "20px",
              }}
            >
              <Form.Group style={{ width: "100%" }} controlId="formName">
                <Form.Control
                  type="text"
                  placeholder="Nom*"
                  value={name}
                  onChange={(event) => setName(event.target.value)}
                />
              </Form.Group>{" "}
              <Form.Group style={{ width: "100%" }} controlId="formEmail">
                <Form.Control
                  type="tel*"
                  placeholder="Telephone"
                  value={telephone}
                  onChange={(event) => setTelephone(event.target.value)}
                />
              </Form.Group>
            </div>

            <Form.Group
              style={{ width: "100%", marginBottom: "20px" }}
              controlId="formEmail"
            >
              <Form.Control
                type="email*"
                placeholder="Email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
            </Form.Group>

            <Form.Group
              style={{ width: "100%", marginBottom: "20px" }}
              controlId="formList"
            >
              <Form.Control
                type="list*"
                placeholder="list"
                value={subject}
                onChange={(event) => setSubject(event.target.value)}
              />
            </Form.Group>

            <Form.Group
              style={{ width: "100%", marginBottom: "20px" }}
              controlId="formMessage"
            >
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Message"
                value={message}
                onChange={(event) => setMessage(event.target.value)}
              />
            </Form.Group>

            {loading ? (
              <Button
                disabled="true"
                className={"ContactUsSubmitButton"}
                variant="primary"
                type="submit"
              >
                {" "}
                <Spinner animation="border" />
              </Button>
            ) : (
              <div style={{ display: "flex", gap: "20px" }}>
                <button
                  className={"ContactUsCancelButton"}
                  onClick={handleClose}
                >
                  Plus Tard
                </button>
                <Button
                  className={"ContactUsSubmitButton"}
                  variant="primary"
                  type="submit"
                >
                  Envoyer
                </Button>
              </div>
            )}
          </Form>
        )}
      </Modal>
    </>
  );
};

export default OurService;
